import { render, staticRenderFns } from "./ObjectCardWrapper.vue?vue&type=template&id=eddeee4c&scoped=true&"
import script from "./ObjectCardWrapper.vue?vue&type=script&lang=js&"
export * from "./ObjectCardWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddeee4c",
  null
  
)

export default component.exports